export default __webpack_public_path__ + "static/media/frame.7608f9af.svg";